export class ValetHttp {
    /**
     * Get all technicians
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async getTechnicians() {
        try {
            return await window.axios.get(`valets`);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Create a new technician
     * @param technician
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async createNewTechnician(technician) {
        try {
            return await window.axios.post(`valets`, technician);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Update a technician
     * @param technician
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async updateTechnician(technician) {
        try {
            return await window.axios.put(`valets`, technician);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Archive a technician
     * @param id
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async archiveTechnician(id) {
        try {
            return await window.axios.delete(`valets/${id}`);
        } catch (e) {
            return Promise.reject(e);
        }
    }
}
